import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SortFilterObject } from 'app/model/entity/sort-filter-object';
import { AppState } from 'app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class SortFilterLCDLayoutEditorService {
  /**
   * Sort filter
   */
  private sortFilterLCDLayoutEditor: SortFilterObject;
  constructor(public readonly store: Store<AppState>) {
    this.store
      .select(state => state)
      .subscribe((componentState: any) => {
        this.sortFilterLCDLayoutEditor =
          componentState?.sortFilterLCDLayoutEditorState?.stateOfComponent?.sortFilterLCDLayoutEditor ?? new SortFilterObject();
      });
  }

  /**
   * Get sort filter object
   *
   * @returns
   */
  public getSortFilterObject(): SortFilterObject {
    return this.sortFilterLCDLayoutEditor;
  }
}
